import * as React from "react";
import { NameView } from "./styles";

export interface NameViewsProps {
  name: string;
  columnNum: number;
  titleTag?: string;
}
export const NameViews = (props: NameViewsProps) => {
  const { name, titleTag, columnNum } = props;

  return (
    <NameView columnNum={columnNum}>
      {titleTag && <img className={"titleTag"} src={titleTag} alt="" />}
      {name}
    </NameView>
  );
};
